import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
    FormComponent,
    IFormDialogData,
} from "src/app/shared/form/form.component";
import { TaskGroup } from "src/app/models/taskGroup.model";
import { forkJoin } from "rxjs";
import { HierarchicalSelectionFormField, TextFormField } from "src/app/shared/form/formField.model";
import nameOf from "src/app/shared/form/nameOf.helper";
import { TaskGroupService } from "src/app/services/taskGroup.service";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { toOrganizationTree } from "src/app/_helpers/org-tree-helper";
import { OrganizationLevel } from "src/app/models/organizationLevel.model";
import { OperatorTypeEnum } from "src/app/enums/operatorType.enum";
import { OrgLevelTypeEnum } from "src/app/enums/orgLevelType.enum";

@Component({
  standalone: false,
    selector: "app-task-group-dialog",
    templateUrl: "./../../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../../shared/form/form.component.scss"],
})
export class TaskGroupDialog
    extends FormComponent<TaskGroup>
    implements OnInit
{
    organizationLevels: OrganizationLevel[];

    constructor(
        dialogRef: MatDialogRef<TaskGroupDialog>,
        @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
        taskGroupService: TaskGroupService,
        private organizationLevelService: OrganizationLevelService,
        protected injector: Injector,
    ) {
        super(dialogRef, taskGroupService, data, "Task Groups", injector);
    }

    ngOnInit() {
        this.isFormLoading = true;
        const orgPayload = JSON.stringify({
            OperatorTypeEnum: JSON.stringify({
                Condition: OperatorTypeEnum.Equal,
                Field: nameOf<OrganizationLevel>((x) => x.orgLevelType),
                Value: `${OrgLevelTypeEnum.Site},${OrgLevelTypeEnum.Function},${OrgLevelTypeEnum.BusinessUnit},${OrgLevelTypeEnum.Corporate}`,
            }),
        });
        forkJoin({
            entity: this.getEntity(),
            organizationLevels: this.organizationLevelService.getAll(orgPayload),
        }).subscribe({
            next: (result) => {
                this.entity = result.entity;
                this.organizationLevels = result.organizationLevels as OrganizationLevel[];
                this.initFields();
                this.isFormLoading = false;
            },
            error: (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        });
    }

    getNewObject(): TaskGroup {
        return new TaskGroup();
    }

    onBeforeSave(model: TaskGroup): void {}

    validate(): boolean {
        return true;
    }

    initFields() {
        this.fields = [
            new TextFormField({
                property: nameOf<TaskGroup>((x) => x.name),
                name: "Task Group Name",
            }),
            new HierarchicalSelectionFormField({
                property: nameOf<TaskGroup>((x) => x.organizationLevelId),
                name: "Organization Level",
                options: toOrganizationTree(this.organizationLevels),
                required: true,
            }),
        ];
    }
}
